import { useCommissionerActAs } from '@/contexts/CommissionerActAsContext';
import { Button } from '@/components/ui/button';
import { ShieldAlert, X } from 'lucide-react';

// Persistent banner that surfaces commissioner-on-behalf mode at the top of
// roster / lineup / trades pages. SAB-341: "banner stays visible at top of
// the roster page so the commissioner never forgets they're not on their
// own team."
//
// Mounted at app-shell level so it survives client-side navigation (the
// CommissionerActAsContext provider is the source of truth; this component
// just renders).

export function CommissionerActingAsBanner() {
  const { isActingAs, actAsTeamName, exitMode } = useCommissionerActAs();

  if (!isActingAs) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-[60] w-full border-b border-amber-500/40 bg-amber-500/15 backdrop-blur-md"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="container mx-auto flex items-center justify-between gap-3 px-4 py-2 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <ShieldAlert className="h-4 w-4 shrink-0 text-amber-500" />
          <span className="truncate">
            <span className="font-semibold text-amber-700 dark:text-amber-300">Commissioner mode</span>
            <span className="text-foreground/80">, acting on behalf of </span>
            <span className="font-semibold text-foreground">{actAsTeamName}</span>
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={exitMode}
          className="shrink-0 h-7 gap-1 text-xs"
          aria-label="Exit commissioner mode"
        >
          <X className="h-3.5 w-3.5" />
          Exit
        </Button>
      </div>
    </div>
  );
}

export default CommissionerActingAsBanner;
